
import { useEffect, useState } from 'react';
import { houseRequest } from '../utils/request';

import '../App.css';

const HouseCard = (props) => {
  const [houseData, setHouseData] = useState({});

  useEffect(() => {
    getHouseData();
    console.log(props.house);
  }, [])

  const getHouseData = async () => {
    const { hid, index, setData } = props;
    const res = await houseRequest(hid);
    setHouseData({
      ...res.house,
      ...res.metric
    });
    if (index === 0) {
      setData(res.metric);
    }
  }

  return (
    <div className="house-card">
      <p className="house-name">{houseData.name}</p>
      <div className="house-data">
        <div className="img">
          <img src={props.house.img} alt="" />
        </div>
        <div className="data-list">
          <div className="data-item">
            <span>{houseData.i_temp || 0} ℃</span>
            <p>大气温度</p>
          </div>
          <div className="data-item">
            <span>{houseData.i_hum || 0} RH</span>
            <p>大气湿度</p>
          </div>
          <div className="data-item">
            <span>{houseData.s_temp || 0} ℃</span>
            <p>土壤温度</p>
          </div>
          <div className="data-item">
            <span>{houseData.s_hum || 0} RH</span>
            <p>土壤湿度</p>
          </div>
          <div className="data-item">
            <span>{houseData.s_ph || 0} PH</span>
            <p>土壤PH</p>
          </div>
          <div className="data-item">
            <span>{houseData.i_sun || 0} Lux</span>
            <p>光照度</p>
          </div>
          <div className="data-item">
            <span>{houseData.i_co2 || 0} ppm</span>
            <p>CO₂</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HouseCard;
